import React from 'react'
export default () => {
  return <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3V0L13 3.5L9 7V4H0V3H9Z" fill="black" />
  </svg>
}
